<mat-form-field appearance="fill" *ngIf="appearance === 'fill'">
    <mat-label>Asset type</mat-label>
    <mat-select [formControl]="assetTypeCtrl">
        <mat-option *ngFor="let assetType of assetTypes$ | async" [value]="assetType">
            {{ assetType | strictTitleCase }}
        </mat-option>
    </mat-select>
    <mat-hint>Select asset type</mat-hint>
    <mat-error>
        <ng-container *ngIf="assetTypeCtrl.hasError('required')">
            Select asset type
        </ng-container>
    </mat-error>
</mat-form-field>
<mat-select
    class="sb-appearance-none"
    [formControl]="assetTypeCtrl"
    *ngIf="appearance === 'none'"
>
    <mat-option *ngFor="let assetType of assetTypes$ | async" [value]="assetType">
        {{ assetType | strictTitleCase }}
    </mat-option>
</mat-select>
